import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const token = localStorage.getItem("token");
    const parsedToken = token ? JSON.parse(token) : "";

    return openSocket(getBackendUrl(), {
      // Deixamos apenas o polling e websocket. Se o upgrade falhar, ele mantém o polling ativo e funcional!
      transports: ["polling", "websocket"], 
      upgrade: true,
      rememberUpgrade: typeof window !== "undefined",
      timeout: 20000, // Dá mais tempo para o handshake responder
      withCredentials: true,
      query: {
        token: parsedToken,
      },
    });
}

export default connectToSocket;
